import { AppThunk } from '@legacyApp/types/store/ThunkAction';
import { optionsDisable } from '@legacyApp/client/store/options/options.actions';
import { OPTIONS } from '@legacyApp/client/store/options/options.constants';
import { lsSet } from '@modules/localStorage/methods/lsSet';
import { LocalStorageKeys } from '@modules/localStorage/types/localStorageKeys.type';
import { checkLowPerformance } from '../methods/checkLowPerformance';
import { performanceSetIsLowPerformance } from './performance.action';

export const performanceTest = (): AppThunk => {
	return (dispatch, getState) => {
		console.log('performanceTest', getState().performance);
		if (getState().performance.isLowPerformance !== null) {
			return;
		}
		checkLowPerformance((isLow) => {
			lsSet(LocalStorageKeys.IS_LOW_PERFORMANCE, isLow);
			dispatch(performanceSetIsLowPerformance(isLow));
		});
	};
};

export const adaptAppToLowPerformance = (): AppThunk => {
	return (dispatch) => {
		dispatch(optionsDisable(OPTIONS.SOUND, true));
		dispatch(optionsDisable(OPTIONS.ANIMATION, true));
		dispatch(optionsDisable(OPTIONS.AUTOBET_CHART, true));
		dispatch(optionsDisable(OPTIONS.CHART, true));
	};
};
